enum PageState {
    MainPage,
    SettingsPage,
    DownloadPage
}

export default PageState;